import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@inject(Router)
export class Error {
    constructor(router) {

        this.router = router;

        this.logo_img = "images/magnfi-logo-small.png";
        this.app_name = "Magnfi";
       
    
        this.home_url = window.home_url;
        this.site_url = window.site_url;
        this.supportEmail = window.support_email;
        if(window.whitelabel) {
          this.whitelabel = window.whitelabel;
          this.logo_img = "api/whitelabel/getFile?file=site_logo";
          this.app_name = window.app_name;

        }
        
    }

    activate(model) {
        if(model.url)
            this.reloadURL = model.url;
        else
            this.reloadURL = "";

        this.permissionDenied = false;
        if(model.permission_denied)
            this.permissionDenied = true;

        this.showTS = false;
    }


    reload() {
        this.router.navigate("#/capture/" + this.reloadURL, { replace: true });
    }

}